import client from './client';

export const createUser = async (user) => {
  const {
    email,
    password,
    firstName,
    lastName,
    inviteLink,
  } = user;

  const data = {
    email,
    password,
    first_name: firstName,
    last_name: lastName,
    invite_link: inviteLink,
  };

  const response = await client.post('users', data);

  return response.data;
};
